import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "returnNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.RETURN.fullString,
    hasInputLabel: true,
  },
];
